import { render } from "./MobileAccountEmailForm.vue?vue&type=template&id=08bd56ee"
import script from "./MobileAccountEmailForm.vue?vue&type=script&lang=js"
export * from "./MobileAccountEmailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mobile/account_center/components/MobileAccountEmailForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08bd56ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08bd56ee', __exports__)) {
    api.reload('08bd56ee', __exports__)
  }
  
  module.hot.accept("./MobileAccountEmailForm.vue?vue&type=template&id=08bd56ee", () => {
    api.rerender('08bd56ee', render)
  })

}


export default __exports__